import React, { useEffect, useRef } from 'react';
import styles from './ourTrend.scss';
import Page1 from './Page1';
import $ from 'jquery';
import { SCROLL_DELTA, animationDom } from '../func';
import _ from 'lodash';

function OurTrend(props) {
  const {
    curPanel,
  } = props;

  const page1 = useRef(null);
  const startPos = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      const ele = document.getElementById('ourTrend');

      function scrollHorizontally(e) {
        e = window.event || e;
        var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
        $(ele).animate({ scrollLeft: `+=${-delta * SCROLL_DELTA}` }, 150, 'linear');
        e.preventDefault();
      }

      const throttleFunc = _.throttle(scrollHorizontally, 150);

      if (ele.addEventListener) {
        // IE9, Chrome, Safari, Opera
        ele.addEventListener('mousewheel', throttleFunc, false);
        // Firefox
        ele.addEventListener('DOMMouseScroll', throttleFunc, false);
      } else {
        // IE 6/7/8
        ele.attachEvent('onmousewheel', throttleFunc);
      }

      //所有页面总宽度
      const page1Width = page1.current.clientWidth;
      const totalWidth = page1Width;
      const scrollBar = document.getElementById('scrollbar-ourTrend');
      const viewWidth = document.getElementById('ourTrend').offsetWidth;
      const windowWidth = document.body.offsetWidth;
      const bar = scrollBar.childNodes[0];
      const maxScrollLeft = totalWidth - viewWidth;
      const maxBarLeft = windowWidth - bar.offsetWidth;

      ele.addEventListener('scroll', (e) => {
        animationDom();

        const scrollLeft = ele.scrollLeft;

        //自定义滚动条
        // bar.style.left = `${maxBarLeft * scrollLeft / maxScrollLeft}px`;
        bar.style.width = `${maxBarLeft * scrollLeft / maxScrollLeft}px`;
      });

      // window.addEventListener('mousemove', e => {
      //   if (!startPos.current) return;

      //   const pageX = e.pageX;

      //   const prevLeft = parseFloat(getComputedStyle(bar)['left']);
      //   let newLeft = prevLeft + 2 * (pageX - startPos.current.x);
      //   if (newLeft > maxBarLeft) {
      //     newLeft = maxBarLeft;
      //   } else if (newLeft < 0) {
      //     newLeft = 0;
      //   }
      //   ele.scrollLeft = `${(newLeft / maxBarLeft) * (maxScrollLeft)}`;

      //   startPos.current = { x: pageX };
      // });

      window.addEventListener('mouseup', () => {
        startPos.current = null;
      });
    }, 1000);
  }, []);

  return (
    <div id='ourTrend' className={`${styles['ourTrend']} ${curPanel === 'ourTrend' ? styles.show : styles.hide}`}>
      <Page1 myRef={page1} />

      <div id='scrollbar-ourTrend' className={styles.scrollBar}>
        <div
          className={styles.bar}
          onMouseDown={e => {
            startPos.current = {
              x: e.pageX,
            };
          }}
        />
      </div>
    </div>
  );
}

export default OurTrend;